import React, { useEffect, useState } from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import HomeSkeleton from "../../component/users/Home/Skeleton";
import Footer from "../../component/users/Footer";
import { Add } from "@mui/icons-material";
// import AddClubForm from "../../component/users/AddClub/AddTournamentForm";
import AddLeagueForm from "../../component/users/AddLeagues/AddTournamentForm";
import LoaderLayout from "../../component/users/LoaderLayout";
import { getGoal } from "../../api/getGoal";
import { authenticateUser } from "../../helper/authentication";
import { toast } from "react-toastify";

const AddGoal = () => {
  const userData = useSelector((state) => state.loggedUser.user);
  const user = useSelector((state) => state.user.loading);

  return (
    <>
      <Header />

      {user ? (
        <LoaderLayout />
      ) : (
        <Box className="userLayout addGoal">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743" }}
          >
            <Box className="addGoal-wrapper addTournament-wrapper">
              <AddLeagueForm />
            </Box>
            <Footer />
          </Container>
        </Box>
      )}
    </>
  );
};

export default AddGoal;
